import creditEngineRepository, {CreditEngineRepository} from "@/repositories/creditengine/CreditEngineRepository";

const resource = "/hooks";
export default {
  notifyDataTableEvent(dataTableName, event, commandProcessingGenericResponse) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
        `${resource}/${dataTableName}/${event}`,
        commandProcessingGenericResponse
    );
  }
}